import React from 'react';
import {
  TopBar,
  TopBarLeft,
  TopBarRight,
  Menu,
  MenuItem
} from 'react-foundation';
import CreateAccountModal from '../create-account/create-account';
import FaBars from 'react-icons/lib/fa/bars';
import SignInModal from '../login/login';
import { toggleMenu } from '../../state/toggle/actions';
import { clearJob } from '../../state/jobs/actions';
import { push } from 'react-router-redux';

export const Navbar = React.createClass({
  renderLogo() {
    let logoName = 'logo-light-bg.png';
    if (this.props.bgColor === 'dark') {
      logoName = 'logo-dark-bg.png';
    }
    return (
      <img
        className="nav-logo"
        src={`../../assets/navbar/${logoName}`}
        alt="Logo"
      />
    );
  },

  render() {
    const { isAuthenticated, dispatch, title } = this.props;
    return (
      <TopBar className="navbar">
        <TopBarLeft className="navbar__left">
          {isAuthenticated ? (
            <FaBars size={24} onClick={() => dispatch(toggleMenu(true))} />
          ) : null}
          <a href="/">{this.renderLogo()}</a>
        </TopBarLeft>
        <span className="navbar-title hide-for-small-only"> {title} </span>
        <TopBarRight className="navbar__right hide-for-small-only">
          {isAuthenticated ? (
            <Menu>
              <a
                onClick={() => {
                  dispatch(clearJob());
                  dispatch(push('/create-job'));
                }}
              >
                Create Job
              </a>
              <a onClick={() => dispatch(push('/jobs'))}>View Jobs</a>
            </Menu>
          ) : (
            <Menu>
              <MenuItem>
                <CreateAccountModal />
              </MenuItem>
              <MenuItem>
                <SignInModal />
              </MenuItem>
            </Menu>
          )}
        </TopBarRight>
      </TopBar>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./src/components/navbar/navbar.js
 **/